import React, { useState, useEffect } from 'react';
import Country from '../body/country/index'
import axios from 'axios'


function Body() {
    const [countObects, setCount] = useState(0);

    useEffect(() => {
        axios.get('https://thai.hub360.info/api/get-count-objects&lang=ru')
            .then(function (response) {
                setCount(response.data)
            })
    }, []);

    return (
        <div className="panel__body">
            <Country
                country='russia'
                active={false}
            />
            <Country
                country='usa'
                active={false}
            />
            <Country
                country='malasiya'
                active={false}
            />
            <div className="country-item country-item_advertising">

            </div>
            <div className="country-item country-item_advertising-two">

            </div>
            <Country
                country='thailand'
                active={true}
                countObects={countObects}
            />
            <Country
                country='honk-kong'
                active={false}
            />
            <Country
                country='macau'
                active={false}
            />
            <Country
                country='france'
                active={false}
            />
            <div className="country-item country-item_advertising-three">

            </div>
            <div className="country-item country-item_advertising-four">

            </div>
            <Country
                country='china'
                active={false}
            />
        </div>
    )
}

export default Body